import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=a3a31dd4&scoped=true&"
import script from "./PhonePreview.vue?vue&type=script&lang=js&"
export * from "./PhonePreview.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&id=a3a31dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a31dd4",
  null
  
)

export default component.exports